import React from 'react';
import { Page, Content, Nav, Loading } from '@beisen/chaos-ui';
import Button from '../Field_Components/Button/Button';
import {
    createQueryObject,
    ifHidePopupNav,
    clearHeaderConfig,
    generateHeaderConfig
} from '../util/helper';
import * as approvelHelper from '../util/approvelHelper';
import * as urlHelper from '../util/url';
import SubLoading from '../Form/SubLoading/loading';
import transLoader from '@beisen/i18n-translation-loader';
import classNames from 'classNames';
import { addEnNavClassName } from '../util/ui';
require('./approvalForm.scss');
const defaultTranslation = {
    required: '必填',
    cancel: '取消',
    confirm: '确定'
};
export default class ApprovalForm extends React.Component {
    constructor(props) {
        super(props);
        this.renderFields = this.renderFields.bind(this);
        this.saveData = this.saveData.bind(this);
        this.stopLoadForField = this.stopLoadForField.bind(this);
        /**用字段的name作为key值存储字段数据start*/
        this.wf_Comment = null;
        this.wf_TransferTo = null;
        this.wf_NextApprover = null;
        this.wf_JumpTo = null;
        /**用字段的name作为key值存储字段数据end */
        
        this.fields =
            approvelHelper.getExistFields(this.props.popOptions) || [];
        this.state = {
            disabled: false,
            wf_CommentError: null,
            wf_TransferToError: null,
            wf_JumpToError: null,
            isShowLoading: false,
            loadForField: this.needLoadForField()
        };
        this.translation = Object.assign(
            {},
            defaultTranslation,
            transLoader({
                confirm: 'common.confirm',
                required: 'common.required',
                cancel: 'common.cancel'
            }),
            props.translation
        );
    }

    needLoadForField() {
        // 如果审批组件需要请求数据源 则添加此loading 解决接口数据返回慢时，组件没有数据展示
        return (
            this.fields.filter(item => {
                return item.needFormLoad;
            }).length > 0
        );
    }

    componentDidMount() {
        if (ifHidePopupNav()) {
            this.registCallback();
            this.setBoxHeader();
        }
    }

    componentWillReceiveProps(nextProps) {
        if (!this.props.error && nextProps.error) {
            this.stopLoading();
        }
    }

    componentWillUnmount() {
        if (ifHidePopupNav()) {
            this.clearCallback();
            this.getPreHeaderConfig();
        }
    }

    cancelEdit() {
        this.props.actions.btnClearFn();
    }

    setError(fieldName, fieldLabel, message) {
        this.setState({
            [`${fieldName}Error`]: { message }
        });
        this.props.actions.showTip({
            message: `${fieldLabel}:${message}`,
            type: 'error'
        });
    }

    validate() {
        
        const { translation } = this;
        for (let i = 0; i < this.fields.length; i++) {
            const field = this.fields[i];
            const isCombineField = Array.isArray(field.taskKey);
            if (isCombineField) {
                for (let n = 0; n < field.taskKey.length; n++) {
                    let item = field.taskKey[n];
                    if (this[`${item.name}Required`] && !this[item.name]) {
                        this.setError(
                            item.name,
                            item.label,
                            translation.required
                        );
                        return false;
                    }
                }
            } else {
                const fieldName = field.name;
                const fieldData = field.getMetaData(this.props.popOptions);
                const validators = fieldData.validators;
                if (fieldData['required'] && !this[fieldName]) {
                    this.setError(
                        fieldName,
                        fieldData['cmp_label'],
                        translation.required
                    );
                    return false;
                } else if (!this.validateLength(this[fieldName], validators)) {
                    this.setError(
                        fieldName,
                        fieldData['cmp_label'],
                        validators.length.tooLong.substring(1)
                    );
                    return false;
                }
            }
        }

        return true;
    }
    //校验最大长度
    validateLength(value, validators) {
        if (
            !validators ||
            !validators.length ||
            !validators.length.maximum ||
            !value
        ) {
            return true;
        }
        return value && value.length <= validators.length.maximum;
    }
    appendParams(fetchUrl) {
        const queryObj = createQueryObject(window.location.href);
        for (let prop in queryObj) {
            if (prop.startsWith('_') && queryObj.hasOwnProperty(prop)) {
                const val = queryObj[prop];
                fetchUrl = fetchUrl + `&${prop}=${val}`;
            }
        }
        return fetchUrl;
    }

    startLoading(cb) {
        this.setState({ isShowLoading: true }, cb);
    }

    stopLoading() {
        this.setState({ isShowLoading: false });
    }

    completeTask(extendInfo) {
        this.setState({ disabled: true });
        let fetchUrl = urlHelper.keepHttpsProtocolSame(
            this.props.popOptions.params.completeTaskUrl
        );
        this.props.actions.completeTask(
            fetchUrl,
            extendInfo,
            [
                function(resp) {
                    this.stopLoading();
                    this.setState({ disabled: false });
                    if (
                        resp &&
                        resp.data &&
                        resp.data.code &&
                        resp.data.code != '200'
                    ) {
                        return null;
                    }
                    // 后加签及并加签应该留在当前审批详情页
                    const hasSign =
                        this.fields.filter(item => {
                            return item.name == 'wf_AddSign';
                        }).length > 0;
                    resp['data']['needBackToDetail'] =
                        hasSign &&
                        (extendInfo.addSignType == approvelHelper.SIGNAFTER ||
                            extendInfo.addSignType == approvelHelper.SIGNAND);
                    resp['data']['needReload'] =
                        extendInfo.addSignType == approvelHelper.SIGNAND; // 并加签需要刷新详情页
                    this.props.actions.btnNextFn({
                        resultData: resp
                    });
                }.bind(this)
            ],
            function() {
                this.setState({ disabled: false });
                this.stopLoading();
            }.bind(this),
            this.props.analysisData
        );
    }

    //注意http-code 是200 但是 response code 是417的情况是否能够正确显示
    saveData() {
        if (this.validate()) {
            let extendInfo = {};
            this.fields.forEach(field => {
                if (Array.isArray(field.taskKey)) {
                    field.taskKey.forEach(item => {
                        extendInfo[item.taskKey] = this[item.name] || '';
                    });
                } else {
                    extendInfo[field.taskKey] = this[field.name] || '';
                }
            });

            this.startLoading(() => {
                // if(this.props.popOptions.params.ajaxUrl) {
                //     //审批意见与ajax同时在保存中处理的逻辑
                //     const queryObj = createQueryObject(window.location.href);
                //     const commentKey = BSGlobal.loginUserInfo.Id + "_" + queryObj['_processInstanceId'] + '_comment';
                //     window.sessionStorage.setItem(BSGlobal.loginUserInfo.Id + "_" + queryObj['_processInstanceId'] + '_comment',this.comment);
                //     this.props.actions.btnNextFn();
                // }else {
                //console.log(extendInfo);
                this.completeTask(extendInfo);
                // }
            });
        }
    }

    stopLoadForField() {
        this.setState({ loadForField: false });
    }

    clearError(field) {
        if (this.state[`${field.name}Error`]) {
            this.setState({
                [`${field.name}Error`]: null
            });
        }
    }

    handleChange(field, obj) {
        if (Array.isArray(obj)) {
            obj.forEach(item => {
                this[item.name] = item.value;
                this[`${item.name}Required`] = item.required;
            });
        } else {
            this[field.name] = obj.value;
            this[`${field.name}Text`] = obj.text;
        }
    }

    renderFields() {
        return (
            this.fields.length > 0 &&
            this.fields.map((field, index) => {
                const Cmp = field.cmp;
                return (
                    <Cmp
                        key={index}
                        {...field.getMetaData(this.props.popOptions)}
                        text={this[`${field.name}Text`]}
                        stopLoadForField={this.stopLoadForField}
                        onFocus={this.clearError.bind(this, field)}
                        onBlur={this.handleChange.bind(this, field)}
                        onChange={this.handleChange.bind(this, field)}
                        errorMessage={this.state[`${field.name}Error`]}
                        actions={this.props.actions}
                        analysisData={this.props.analysisData}
                    />
                );
            })
        );
    }

    /********************************导航相关设置Start *********************************/
    //设置壳子的导航对象并通知壳子更新导航
    setBoxHeader() {
        const title = this.props.popOptions.params.title;
        generateHeaderConfig(function(headerConfig, setButton) {
            let config = Object.assign({}, headerConfig);
            const left_item = [
                {
                    callback: 'approvalFormCancel',
                    control: true,
                    type: 'back'
                }
            ];
            config = setButton('left', left_item, config);
            config.titleItem = {
                text: title,
                icon: '',
                callback: '',
                control: false
            };
            return config;
        });
    }

    //组件销毁后获取前一个壳子的配置对象并通知壳子进行更新
    getPreHeaderConfig() {
        clearHeaderConfig();
    }

    //注册壳子回调函数
    registCallback() {
        window.globalEventManager['approvalFormCancel'] = this.cancelEdit.bind(
            this
        );
    }

    //清除壳子回调函数
    clearCallback() {
        delete window.globalEventManager['approvalFormCancel'];
    }
    /********************************导航相关设置End *********************************/

    render() {
        const { translation } = this;
        if (
            !this.props.popOptions ||
            !this.props.popOptions.params ||
            !this.props.popOptions.params.useTemplate
        ) {
            return null;
        }
        let navStyle = ifHidePopupNav() ? { display: 'none' } : {};
        const enNavButtonClass = addEnNavClassName();
        return (
            <Page cls="edit-form approval-form">
                <Nav cls="editform-navbar" style={navStyle}>
                    <div role="center" className="approvalInfo-title">
                        {this.props.popOptions.params.title}
                    </div>
                    <a
                        role="left"
                        href="javascript:;"
                        className={classNames(
                            'editform-cancle-btn',
                            enNavButtonClass
                        )}
                        onTouchTap={this.cancelEdit.bind(this)}>
                        {translation.cancel}
                    </a>
                </Nav>
                <Content>
                    <div className="approveform-content">
                        {this.state.loadForField ? (
                            <Loading
                                bgstyle={{
                                    position: 'absolute',
                                    zIndex: 1,
                                    background: '#f2f4f5'
                                }}
                            />
                        ) : null}
                        <div className="list-block inputs-list">
                            {this.renderFields()}
                        </div>
                        <Button
                            cmp_label={translation.confirm}
                            type="primary"
                            ref="btn"
                            disabled={this.state.disabled}
                            onTouchTap={this.saveData}
                        />
                    </div>
                </Content>
                {this.state.isShowLoading ? <SubLoading /> : null}
            </Page>
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/Approval/ApprovalForm.js